const Months = [
  {
    id: '1',
    name: '01 - January',
  },
  {
    id: '2',
    name: '02 - Febuary',
  },
  {
    id: '3',
    name: '03 - March',
  },
  {
    id: '4',
    name: '04 - April',
  },
  {
    id: '5',
    name: '05 - May',
  },
  {
    id: '6',
    name: '06 - June',
  },
  {
    id: '7',
    name: '07 - July',
  },
  {
    id: '8',
    name: '08 - August',
  },
  {
    id: '9',
    name: '09 - September',
  },
  {
    id: '10',
    name: '10 - October',
  },
  {
    id: '11',
    name: '11 - November',
  },
  {
    id: '12',
    name: '12 - December',
  },
];

export { Months };
export default {
  Data: {
    data() {
      return { months: Months };
    },
  },
};
